export const FIREBASE_TABLE_FILTER_NUMBER_OPERATORS = [
  "==",
  "!=",
  "<",
  "<=",
  ">",
  ">=",
] as const;
